import { Injectable } from '@angular/core';
import { HttpUtils } from '../utils/http-utils';
import { ClientUtilities } from '../utils/client-utils';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FeatureEnablementService {

    public isRunningInNGC: boolean = false;
    private apiBase: string;
    private featureEnablementApi: string;

    constructor(public http: HttpClient) {
        this.isRunningInNGC = ClientUtilities.runningInPluginUI();

        const path = (window.location.pathname.match(/(.*)(\/publisher-ui)(\/.*|$)/) || [])[1];
        this.apiBase = (!!path && !!this.isRunningInNGC) ? path + '/hcx-ui/rest' : '';
        if(environment.loadedInVCRemotePlugin) {
            this.apiBase = HttpUtils.getBaseUrl();
        }
        this.featureEnablementApi = this.apiBase + '/hybridity/api/featureConfig';
    }

    public getFeatureEnablement(vcGuid: string, payload: object) {

        return this.http.post(this.featureEnablementApi + '?hcspUUID=' + vcGuid + '&action=query',
            payload);
    }
}



// WEBPACK FOOTER //
// ./src/publisher/src/publisher-ui/upgrade/feature-enablement.service.ts